/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useState } from "react";
import { WebpageSelector } from "components/webpage-selector";
import { WebpageDisplayComponent } from "./webpage-display-component";
import { WebpageAddComponent } from "./webpage-add-component";

const WebpageSelectorWrapper = (props) => {
    
    const {
        onWebpageChange,
        onWebpageRemove,
        filter,
        filterValue = props.filterValue,
        webpage: _webpage
    } = props;
    
    const [webpage, setWebpage] = useState(_webpage);
    
    useEffect(() => {
        setWebpage(_webpage);
    }, [_webpage]);
    
    const onSelectWebpage = async (webpage) => {
        setWebpage(webpage);
        onWebpageChange(webpage);
    };
    const onWebpageRemoved = async (webpage) => {
        onWebpageRemove(webpage);
    };
    
    return (
        <WebpageSelector
            AddComponent={WebpageAddComponent}
            DisplayComponent={WebpageDisplayComponent}
            webpage={webpage}
            setWebpage={setWebpage}
            onSelectWebpage={onSelectWebpage.bind(this)}
            onWebpageRemoved={onWebpageRemoved.bind(this)}
            filter={filter}
            filterValue={filterValue}
        />
    );
};

export { WebpageSelectorWrapper };
